export default __webpack_public_path__ + "static/Doubleapy-faa5da63637a3e0af9231b4a9e4a6e65.svg";